export interface Job {
  id: string;
  title: string;
  location: string;
  employmentType: string;
  shortDescription: string;
  detailedDescription: string;
}

export const jobs: Job[] = [
  {
    id: 'frontend-dev',
    title: 'Frontend Developer',
    location: 'Remote',
    employmentType: 'Full-time',
    shortDescription: 'Build and maintain modern web applications using React and TypeScript.',
    detailedDescription: 'As a Frontend Developer, you will work closely with our design and backend teams to deliver high-quality, scalable web applications. You should have experience with React, TypeScript, and responsive design.'
  },
  {
    id: 'backend-dev',
    title: 'Backend Developer',
    location: 'Hanoi',
    employmentType: 'Full-time',
    shortDescription: 'Develop robust backend services and APIs using Node.js and cloud technologies.',
    detailedDescription: 'As a Backend Developer, you will design and implement scalable APIs and services. Experience with Node.js, databases, and cloud platforms is required.'
  },
  {
    id: 'qa-engineer',
    title: 'QA Engineer',
    location: 'Remote',
    employmentType: 'Contract',
    shortDescription: 'Ensure the quality and reliability of our software products through testing and automation.',
    detailedDescription: 'As a QA Engineer, you will develop and execute test plans, automate testing processes, and work with developers to resolve issues. Experience with automated testing tools is a plus.'
  }
];